import { createAction } from 'typesafe-actions'

export const setGlobalEquipmentSearchQuery = createAction('CMD / GlobalSearch / set query')<string>()

export const setGlobalEquipmentSearchQueryState = createAction('DOC / GlobalSearch / set query state')<string>()

export const clearGlobalEquipmentSearchQuery = createAction('CMD / GlobalSearch / clear query')()

export const clearGlobalEquipmentSearchQueryState = createAction('DOC / GlobalSearch / clear query state')()

export const setSearchMode = createAction('CMD / GlobalSearch / set search mode')<'page' | 'global'>()

export const setSearchModeState = createAction('DOC / GlobalSearch / set search mode state')<'page' | 'global'>()

export const resetSearchMode = createAction('CMD / GlobalSearch / reset search mode')()

export const resetSearchModeState = createAction('DOC / GlobalSearch / reset search mode state')()